import SimpleSelect from "component/Common/simpleSelect";
import { childrenAgesOptions } from "helpers/hotelHelper";
import { useHotelContext } from "hooks/hotel/useHotelContext";
import useHotelSearchParams from "hooks/hotel/useHotelSearchParams";
import { Offcanvas, OffcanvasHeader, OffcanvasBody } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { BiMinus, BiPlus } from "react-icons/bi";
import { GrClose } from "react-icons/gr";
import { toast } from "react-toastify";

const MobileGuestsDropdown = ({ isOpen, onHide }) => {
    const { t } = useTranslation();
    const { hotelSearchParams } = useHotelContext();
    const { updateHotelSearchParams, updateGuests } = useHotelSearchParams();
    return (
        <Offcanvas
            placement="bottom"
            show={isOpen}
            onHide={onHide}
            className="h-screen"
            tabIndex={-1}
            id="offcanvasSidebar"
        >
            <OffcanvasHeader className="offcanvas-header p-3 flex items-center justify-between border-b ">
                <div className="text-xl ">Guests & Rooms</div>
                <GrClose size={18} onClick={onHide} cursor={"pointer"} />
            </OffcanvasHeader>
            <OffcanvasBody className="offcanvas-body flex-column p-0 ">
                <div className="flex flex-col py-4 px-8">
                    {hotelSearchParams?.rooms?.map((room, index) => {
                        return (
                            <div className="" key={index}>
                                <div className="flex items-center justify-between mb-8 ">
                                    <div className="">
                                        {t("room")} {index + 1}
                                    </div>
                                    <div
                                        onClick={() => {
                                            if (
                                                hotelSearchParams.rooms
                                                    .length === 1
                                            ) {
                                                toast.error(
                                                    "You must have at least one room"
                                                );
                                                return;
                                            }
                                            updateHotelSearchParams(
                                                "rooms",
                                                hotelSearchParams.rooms.filter(
                                                    (item, i) => i !== index
                                                )
                                            );
                                        }}
                                        className=" bg-red-500 text-white p-1.5 rounded-md text-sm"
                                    >
                                        <GrClose  size={12} />
                                    </div>
                                </div>
                                <div className="my-4 flex flex-col gap-2">
                                    <div className="flex items-center justify-between rounded-md  bg-hover-color p-3 mb-1">
                                        <div className="text-lg">{t("adults")}:</div>
                                        <div className="flex gap-2 items-center">
                                            <div
                                                onClick={() => {
                                                    updateGuests(
                                                        index,
                                                        "adults",
                                                        hotelSearchParams.rooms[
                                                            index
                                                        ].adults - 1,
                                                        "sub"
                                                    );
                                                }}
                                                className="border-2 border-main-color size-8 text-lg font-semibold flex items-center justify-center text-main-color cursor-pointer"
                                            >
                                                <BiMinus size={19} />
                                            </div>
                                            <div className="text-lg  w-8 text-center ">
                                                {
                                                    hotelSearchParams?.rooms[
                                                        index
                                                    ].adults
                                                }
                                            </div>
                                            <div
                                                onClick={() => {
                                                    updateGuests(
                                                        index,
                                                        "adults",
                                                        hotelSearchParams.rooms[
                                                            index
                                                        ].adults + 1,
                                                        "add"
                                                    );
                                                }}
                                                className="border-2 border-main-color size-8 text-lg font-semibold flex items-center justify-center text-main-color cursor-pointer "
                                            >
                                                <BiPlus size={19} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex items-center justify-between rounded-md bg-hover-color p-3 mb-1">
                                        <div className="text-lg">{t("children")}:</div>
                                        <div className="flex gap-2 items-center">
                                            <div
                                                onClick={() => {
                                                    updateGuests(
                                                        index,
                                                        "children",
                                                        hotelSearchParams.rooms[
                                                            index
                                                        ].children - 1,
                                                        "sub"
                                                    );
                                                }}
                                                className="border-2 border-main-color size-8 text-lg font-semibold flex items-center justify-center text-main-color cursor-pointer "
                                            >
                                                <BiMinus size={19} />
                                            </div>
                                            <div className="w-8 text-center ">
                                                {
                                                    hotelSearchParams?.rooms[
                                                        index
                                                    ].children
                                                }
                                            </div>
                                            <div
                                                onClick={() => {
                                                    updateGuests(
                                                        index,
                                                        "children",
                                                        hotelSearchParams.rooms[
                                                            index
                                                        ].children + 1,
                                                        "add"
                                                    );
                                                }}
                                                className="border-2 border-main-color size-8 text-lg font-semibold flex items-center justify-center text-main-color cursor-pointer "
                                            >
                                                <BiPlus size={19} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className=" flex flex-col gap-2 mt-2">
                                        {hotelSearchParams?.rooms[
                                            index
                                        ].childrenAges.map((child, i) => {
                                            return (
                                                <div key={i} className="flex items-center gap-2 justify-between rounded-md  bg-hover-color p-3 mb-1">
                                                    <div className="flex text-lg">
                                                        {t("child")} {i + 1} :
                                                    </div>
                                                    <div className="w-28">
                                                        <SimpleSelect
                                                            options={
                                                                childrenAgesOptions
                                                            }
                                                            isClearable={false}
                                                            searchable={false}
                                                            placeholder="Age.."
                                                            value={childrenAgesOptions.find(
                                                                (age) =>
                                                                    age.value ===
                                                                    child
                                                            )}
                                                            onChange={(
                                                                selectedOption
                                                            ) => {
                                                                updateHotelSearchParams(
                                                                    "rooms",
                                                                    hotelSearchParams.rooms.map(
                                                                        (
                                                                            room,
                                                                            roomIdx
                                                                        ) => {
                                                                            if (
                                                                                roomIdx ===
                                                                                index
                                                                            ) {
                                                                                return {
                                                                                    ...room,
                                                                                    childrenAges:
                                                                                        room.childrenAges.map(
                                                                                            (
                                                                                                age,
                                                                                                ageIdx
                                                                                            ) => {
                                                                                                if (
                                                                                                    ageIdx ===
                                                                                                    i
                                                                                                ) {
                                                                                                    return +selectedOption.value;
                                                                                                }
                                                                                                return age;
                                                                                            }
                                                                                        ),
                                                                                };
                                                                            }
                                                                            return room;
                                                                        }
                                                                    )
                                                                );
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                                {index !==
                                    hotelSearchParams.rooms.length - 1 && (
                                    <hr className=" mb-4" />
                                )}
                            </div>
                        );
                    })}
                    <div
                        onClick={() => {
                            if (hotelSearchParams.rooms.length === 4) {
                                toast.error("You can add at most 4 rooms");
                                return;
                            }
                            updateHotelSearchParams("rooms", [
                                ...hotelSearchParams.rooms,
                                {
                                    adults: 1,
                                    children: 0,
                                    childrenAges: [],
                                },
                            ]);
                        }}
                        className="w-full rounded-md bg-main-color py-2 font-semibold text-md cursor-pointer text-center text-white mt-4"
                    >
                        {t("addRoom")}
                    </div>
                </div>
            </OffcanvasBody>
        </Offcanvas>
    );
};

export default MobileGuestsDropdown;
